import React, { useCallback, useState } from 'react';
import { usePdfExport, useSchoolBranding } from '../../utils/pdf';
import letterService from '../../services/letterService';
import LetterDocument from './pdf/LetterDocument';

/**
 * Download a letter as a PDF, drawn in the browser (LetterDocument) from the
 * letter's print data. Mount it where the download is offered, so the
 * school's logo is loaded before anyone clicks.
 */
export function useLetterPdf() {
  const { branding } = useSchoolBranding();
  const { generate } = usePdfExport();
  /** The letter being prepared — its download control shows a spinner. */
  const [busyId, setBusyId] = useState<string | null>(null);

  const download = useCallback(async (letterId: string) => {
    setBusyId(letterId);
    try {
      // Fetched inside the build, so the loader covers it too; the file is named once it's in.
      let file = 'letter';
      await generate(async () => {
        const letter = await letterService.getLetterPrint(letterId);
        file = `${letter.title}-${letter.student.name}`.replace(/[^\w-]+/g, '-').replace(/-+/g, '-');
        return <LetterDocument letter={letter} branding={branding} generatedAt={new Date().toISOString()} />;
      }, () => `${file}.pdf`);
    } finally {
      setBusyId(null);
    }
  }, [branding, generate]);

  return { download, busyId };
}
